// Externals
import React, { useMemo, useState, useEffect } from "react";
import InputRange from "react-input-range";

import PawActive from "../../static/svg/paw.svg";
// Styles
// $FlowFixMe
import "./Slider.scss";

/*::
type Props = {
    value: number,
    setStateValue: function,
    questionNumber: string,
	options: string[],
	isAnswered: boolean
}
*/

const Slider = (props /*: Props */) /*: any */ => {
	const [hasInput, setHasInput] = useState(false);

	useEffect(() => {
		if (props.isAnswered) {
			let ele = document.getElementsByClassName(
				"slider question-" + props.questionNumber,
			);

			let target = ele[0].querySelector(".input-range__slider");
			target.style.backgroundImage = "url(" + PawActive + ")";

			let targetAlt = ele[0].querySelector(".input-range__track");
			targetAlt.style.background = "#e6eeb6";

			let targetAlt2 = ele[0].querySelector(
				".input-range__track--active",
			);
			targetAlt2.style.background = "#91b03d";
		}
	}, [props.isAnswered, props.questionNumber]);

	const optionIndex = useMemo(() => {
		const foundIndex = props.options.indexOf(props.value);
		if (foundIndex === -1) return 1;
		else {
			return foundIndex + 1;
		}
	}, [props.value, props.options]);

	const handleChange = (value /*: string */) /*: void */ => {
		if (!hasInput) {
			let ele = document.getElementsByClassName(
				"slider question-" + props.questionNumber,
			);

			let target = ele[0].querySelector(".input-range__slider");
			target.style.backgroundImage = "url(" + PawActive + ")";

			let targetAlt = ele[0].querySelector(".input-range__track");
			targetAlt.style.background = "#e6eeb6";

			let targetAlt2 = ele[0].querySelector(
				".input-range__track--active",
			);
			targetAlt2.style.background = "#91b03d";
			setHasInput(true);
		}

		props.setStateValue(value);
	};

	return (
		<div
			data-cy={"slider-q" + props.questionNumber}
			className={"slider question-" + props.questionNumber}
		>
			<div className="labels">
				{props.options.map((option) => {
					return (
						<label
							key={option}
							onClick={() => handleChange(option)}
							className={
								props.value === option ? "selected" : null
							}
						>
							<span
								dangerouslySetInnerHTML={{ __html: option }}
							/>
						</label>
					);
				})}
			</div>
			<InputRange
				value={optionIndex}
				minValue={1}
				maxValue={props.options.length}
				onChange={(value) => handleChange(props.options[value - 1])}
				onChangeStart={(value) =>
					!hasInput && handleChange(props.options[value - 1])
				}
			/>
		</div>
	);
};

// Exports
export default Slider;
